__turbopack_context__.v({
  "listingReportModal": "listing-report-modal-module-scss-module__mP9DSG__listingReportModal",
  "listingReportModal_message": "listing-report-modal-module-scss-module__mP9DSG__listingReportModal_message",
  "listingReportModal_reasonsList": "listing-report-modal-module-scss-module__mP9DSG__listingReportModal_reasonsList",
  "listingReportModal_sendMessage": "listing-report-modal-module-scss-module__mP9DSG__listingReportModal_sendMessage",
  "listingReportModal_title": "listing-report-modal-module-scss-module__mP9DSG__listingReportModal_title",
});
